export default {
  order_methods: {
    delivery: 'Levering',
    pickup: 'Afhentning',
    room_service: 'På stedet',
    table_service: 'På stedet',
  },
  time: '{{time}} min.',
  asap: 'Hurtigst muligt',
  unavailable: 'Utilgængelig',
  ready_in: 'Klar om ',
  buttons: {
    change: 'Skift',
    see_hours: 'Se åbningstider',
    change_location: 'Skift lokation',
    change_time: 'Skift tidspunkt',
  },
};
